export const SURVEY_TIMEOUT_MESSAGE =
  'Sorry for the wait. The system is taking some time to load the survey list, and we are unable to return the results.';

export const SURVEY_SLOW_LOAD_THRESHOLD_MS = 7000;

export const DEFAULT_COUNTRY_CODE = 'US';

export const RESPONDENT_LIST_TEMPLATE_FILE_NAME = 'incl_excl.csv';
export const RESPONDENT_LIST_TEMPLATE_PATH = `/templates/${RESPONDENT_LIST_TEMPLATE_FILE_NAME}`;
